import script from "./TerritorioSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TerritorioSelector.vue?vue&type=script&setup=true&lang=js"

import "./TerritorioSelector.vue?vue&type=style&index=0&id=57c4a848&lang=css"

const __exports__ = script;

export default __exports__